import UserAsset from "./UserAsset";
import { ACLResourceType } from "./ACLResourceType";

export default class UserAssetBackground extends UserAsset {

  public getAssetType = () => {
    return "userBackgrounds";
  }

  public getACLResourceType = () => {
    return ACLResourceType.BACKGROUND;
  }

}



// WEBPACK FOOTER //
// src/opt/atlassian/pipelines/agent/build/src/api/model/UserAssetBackground.ts